export const PriceDiet = (json: IDietsPrice): IDietsPriceModel => {
	const fromJSON = (itemJson: IDietsPrice): IDietsPriceModel => {
		const { price, ...rest } = itemJson
		return {
			price: price || price === 0 ? price / 100 : null,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const priceDietToJSON = (obj: Partial<IDietsPriceModel>): Partial<IDietsPrice> => {
	const { ...rest } = obj
	return {
		...rest,
	}
}
